module.exports = __webpack_public_path__ + "static/media/over-logo.154dc196.svg";